//Modules
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AboutMe } from './components/aboutMe/AboutMe';
import { ContactMe } from './components/contactMe/ContactMe';
import { OtherStuff } from './components/otherStuff/OtherStuff';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FigmaToCode } from './components/projectPages/FigmaToCode';
import { Ticketing } from './components/projectPages/Ticketing';
import { DesignSystem } from './components/projectPages/DesignSystem';
import { Vintach } from './components/projectPages/Vintach';
import { PageTransitionContext } from './components/globalComponents/PageTransitionContext';
import usePageTransition from './components/globalComponents/UsePageTransition';
import CustomCursor from './components/globalComponents/CustomCursor';
import { useLocation } from 'react-router-dom';

const TransitionLayout = ({ children }) => {
  const { handleNavigation, overlayRef } = usePageTransition();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <PageTransitionContext.Provider value={{ handleNavigation }}>
      <CustomCursor />
      <div ref={overlayRef} style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "var(--brand-primary)",
        backgroundImage: "url('/images/loader-texture.webp')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        zIndex: 99999,
        clipPath: "inset(0% 0% 100% 0%)",
        pointerEvents: "none",
        willChange: "clip-path",
        transform: "translateZ(0)"
      }} />
      {children}
    </PageTransitionContext.Provider>
  );
};



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TransitionLayout>  {/* now inside BrowserRouter so useNavigate works */}
        <Routes>
          <Route path='/' element={<App />} />
          <Route exact path='/aboutMe' element={<AboutMe />} />
          <Route exact path='/contactMe' element={<ContactMe />} />
          <Route exact path='/otherStuff' element={<OtherStuff />} />
          <Route exact path='/Projects/FigmaToCode' element={<FigmaToCode />} />
          <Route exact path='/Projects/Ticketing' element={<Ticketing />} />
          <Route exact path='/Projects/Vintach' element={<Vintach />} />
          <Route exact path='/Projects/DesignSystem' element={<DesignSystem />} />
        </Routes>
      </TransitionLayout>
    </BrowserRouter>
  </React.StrictMode>
);